import { render } from "./RecurrencePatternInput.vue?vue&type=template&id=336645b1"
import script from "./RecurrencePatternInput.vue?vue&type=script&lang=ts"
export * from "./RecurrencePatternInput.vue?vue&type=script&lang=ts"
script.render = render

export default script